import logoGlobalong from '../img/logoglob.png';
import logoVita from '../img/logoglob-vita-ok.png';
import {SITE_THEME} from './Config';

const themes = {
    globalong: {
        name: 'globalong',
        brand: 'Globalong',
        logo: logoGlobalong,
        urls: {
            site: 'https://www.globalong.com',
            privacy: 'https://www.globalong.com/vie-privee.html',
            terms: 'https://www.globalong.com/conditions-de-vente.html',
            legal: 'https://www.globalong.com/mentions-legales.html',
            security: 'https://www.globalong.com/securite-des-transactions.html',
            internalRules: 'https://www.globalong.com/blog/wp-content/uploads/2016/08/Re%CC%80glement-inte%CC%81rieur-des-volontaires-Globalong.pdf',
            volunteerPassport: 'https://www.globalong.com/blog/passeport-benevole/',
            appointment: 'https://appt.link/meet-with-globalong/',
            help: 'https://tinyurl.com/Globalong-Espace-Membre',
        },
        email: 'info@globalong.com',
        // display : forme affichée à l'utilisateur ; tel : forme pour le lien tel:
        phone: {display: '04 83 58 08 06', tel: '+33483580806'},
        bank: {
            name: 'Association GlobAlong',
            addressLine1: 'Association GlobAlong',
            addressLine2: '14 Rue Font Martin',
            addressLine3: '34 470 Pérols',
            bankCode: '30002',
            branchCode: '03050',
            accountNumber: '0000070811N',
            ribKey: '27',
            branch: 'CL PEROLS (0350)',
            iban: 'FR94 3000 2030 5000 0007 0811 N27',
            bic: 'CRLYFRPP',
            checkPayeeName: 'Globalong',
        },
        colors: {
            text: 'rgba(0, 0, 0, 0.85)',
            primary: '#1890ff',
            btnBg: '#1890ff',
            btnBgHover: '#40a9ff',
            btnText: '#ffffff',
            link: '#1890ff',
        },
    },
    vita: {
        name: 'vita',
        brand: 'VITA EXPLORERS',
        logo: logoVita,
        urls: {
            site: 'https://www.vita-explorers.dk',
            privacy: 'https://www.vita-explorers.dk/privatlivspolitik.html',
            terms: 'https://www.vita-explorers.dk/salgsbetingelser.html',
            legal: 'https://www.vita-explorers.dk/juridiske-oplysninger.html',
            security: 'https://www.vita-explorers.dk/sikre-transaktioner.html',
            internalRules: 'https://www.vita-explorers.dk/reglement-interieur.pdf',
            volunteerPassport: 'https://www.vita-explorers.dk/passeport-benevole/',
            appointment: 'https://calendly.com/contact-vita-explorers/first',
            help: 'https://tinyurl.com/Globalong-Espace-Membre',
        },
        email: 'contact@vita-explorers.dk',
        // display : forme affichée à l'utilisateur ; tel : forme pour le lien tel:
        phone: {display: '(+45) 89 88 67 71', tel: '+4589886771'},
        bank: {
            name: 'Association GlobAlong',
            addressLine1: 'Association GlobAlong',
            addressLine2: '14 Rue Font Martin',
            addressLine3: '34 470 Pérols',
            bankCode: '30002',
            branchCode: '03050',
            accountNumber: '0000070811N',
            ribKey: '27',
            branch: 'CL PEROLS (0350)',
            iban: 'FR94 3000 2030 5000 0007 0811 N27',
            bic: 'CRLYFRPP',
            checkPayeeName: 'Globalong',
        },
        colors: {
            text: '#003e99',
            primary: '#003e99',
            btnBg: '#005fcc',
            btnBgHover: '#0070ee',
            btnText: '#ffffff',
            link: '#005fcc',
        },
    },
};

export const THEME = themes[SITE_THEME] || themes.globalong;
